import {Product} from "~/dto/Product";

export class OrderItem {
    price: number;
    count: number;
    product: Product
    variant: Product;

    static createFromObj(obj: Object): OrderItem {
        return new OrderItem(
            Product.createFromObj(obj.product),
            Product.createFromObj(obj.variant),
            obj.price,
            obj.count
        );
    }

    constructor(product: Product, variant: Product, price: number, count: number) {
        this.product = product;
        this.variant = variant;
        this.price = price;
        this.count = count;
    }

}